<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="3"/>
    <div class="hxq_subpage">
      <div>
        <div class="hxq_ksxd">
          <div class="hxq_ksxd_h">
            <div class="hxq_ksxd_rt">
              <a href="/">首页</a>&gt;
              <span>快速下单</span>
            </div>
          </div>
          <div class="hxq_ksxd_showpop">
            <a href="javascript: void(0);" @click="isShow=!isShow">快速录入</a>
            <div class="hxq_ksxc_tips1">
              <p>温馨提示：① 直接填写志鹏商品货号（例如：AAA0001）即可快速查找所需商品，批量加入购物车。</p>
              <p>&emsp;&emsp;&emsp;&emsp;&emsp;② 普通个人用户享受志鹏价，认证企业用户享受专属会员价格。</p>
              <p>&emsp;&emsp;&emsp;&emsp;&emsp;③ 所填数量需大于等于商品的最小起订量，低于起订量时，将按商品起订量加入购物车。</p>
              <p>&emsp;&emsp;&emsp;&emsp;&emsp;④ 无法加入购物车的原因可能是列表存在已下架或价格异常（如询价）商品，请删除后操作。</p>
            </div>
          </div>
          <div class="hxq_ksxd_b">
            <div class="hxq_ksxd_b_h clearfix">
              <div class="hxq_ksxd1">
                <!-- <a href="javascript:void(0);" style="color:#000;" @change="handleCheckAllChange">全选</a> -->
                <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              </div>
              <div class="hxq_ksxd2">订货号</div>
              <div class="hxq_ksxd3">品牌名称</div>
              <div class="hxq_ksxd4">出货日</div>
              <div class="hxq_ksxd5">商品描述</div>
              <div class="hxq_ksxd6">单价</div>
              <div class="hxq_ksxd7">数量</div>
              <div class="hxq_ksxd8">金额（元）</div>
              <div class="hxq_ksxd9" style="border-right: none;">操作</div>
            </div>
            <div class="hxq_ksxd_box">
              <ul class="hxq_ksxd_ul" goodsarea>
                <li class="clearfix" v-for="(item,index) in goodsList" :key="index">
                  <div class="hxq_ksxd1 hxq_ksxd_xz">
                    <!-- <input type="checkbox" checkbox autocomplete="off"> -->
                    <el-checkbox  v-model="item.checked" @change="handleCheckedCitiesChange(item.id)"></el-checkbox>
                    <!-- <el-checkbox :label="item.id" @change="handleCheckedCitiesChange"></el-checkbox> -->
                  </div>
                  <div class="hxq_ksxd2 hxq_ksxd_dhh">
                    <div>
                      <el-input v-model="item.new_sku" placeholder="订货号" @blur="onRodeChange(index,item)"></el-input>
                    </div>
                  </div>
                  <div class="hxq_ksxd3 hxq_ksxd_spmc">
                    <div>{{ item.brandName }}</div>
                  </div>
                  <div class="hxq_ksxd4 hxq_ksxd_gg"> {{ item.delivery_time }} </div>
                  <div class="hxq_ksxd5 hxq_ksxd_spms">
                    <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" v-if="item.imgpath">
                      <img :src="item.imgpath" width="48" height="49"/>
                    </router-link>
                    <div v-if="item.imgpath" style="width: 215px;">
                      <div><strong class="fast_title">{{ item.title }}</strong></div>
                      <div class="hxq_ksxd_spms1">
                        <em>起批量</em>
                        <strong>最少{{item.number}}个</strong>
                      </div>
                    </div>
                  </div>
                  <div class="hxq_ksxd6 hxq_ksxd_dj"> ￥{{ item.tax_price }} </div>
                  <div class="hxq_ksxd7 ">
                    <el-input-number v-model="item.limits" :min="item.number || 0" size="mini" label="数量" @change="changeNumber(item)"></el-input-number>
                  </div>
                  <div class="hxq_ksxd8 hxq_ksxd_je">￥{{ item.total }}</div>
                  <div class="hxq_ksxd9 hxq_ksxd_cz" style="border-right: none;">
                    <a href="javascript: void(0);" @click="delGoods(index)">删除</a>
                  </div>
                </li>
              </ul>
            </div>
            <div class="hxq_ksxd_add_btn">
              <a href="javascript: void(0);" @click="addGoods">添加商品</a>
            </div>

            <div class="hxq_ksxd_js">
              <a href="javascript: void(0);" @click="settleAccounts">下单</a>
              <em>已选择 0 件商品总价（不含运费）：<span id="price">￥{{totalAmount}}</span></em>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hxq_faster_pop" v-if="isShow">
      <div class="hxq_faster_pop_h">
        <a href="javascript: void(0);" @click="isShow=!isShow">Ｘ</a>
        批量录入商品货号
      </div>
      <div class="hxq_faster_pop_b">
        <div class="hxq_faster_pop_tips">
          <p>可批量粘贴「商品货号,数量」，以英文半角逗号分割即可，如：</p>
          <p>AAA0001,AAA0002
          </p>
          <div style="height: 10px;"></div>
          <p>注：逗号格式为英文半角！</p>
          <p>注：货号不正确的商品将自动过滤不予添加</p>
        </div>
        <div class="hxq_faster_textarea">
          <!-- <textarea sn_arr></textarea> -->
          <el-input
            type="textarea"
            :rows="3"
            v-model="skuList">
          </el-input>
        </div>
        <div class="hxq_faster_btn">
          <a href="javascript: void(0);" @click="sureSku">确定</a>
          <a href="javascript: void(0);" @click="isShow=!isShow">取消</a>
        </div>
      </div>
    </div>
    <div class="hxq_faster_mask" v-if="isShow"></div>
    <Footer/>
  </div>
</template>
<script>
import api from '@/api/faster'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'
import { mapGetters } from 'vuex'

export default {
  name: 'Faster',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      api,
      goodsList: [{
        id: '',
        sku: '',
        brandName: '',
        delivery_time: '',
        description: '',
        tax_price: '0.00',
        limits: '',
        total: '0.00',
        checked: false,
        new_sku: ''
      },
      {
        id: '',
        sku: '',
        brandName: '',
        delivery_time: '',
        description: '',
        tax_price: '0.00',
        limits: '',
        total: '0.00',
        checked: false,
        new_sku: ''
      },
      {
        id: '',
        sku: '',
        brandName: '',
        delivery_time: '',
        description: '',
        tax_price: '0.00',
        limits: '',
        total: '0.00',
        checked: false,
        new_sku: ''
      },
      {
        id: '',
        sku: '',
        brandName: '',
        delivery_time: '',
        description: '',
        tax_price: '0.00',
        limits: '',
        total: '0.00',
        checked: false,
        new_sku: ''
      },
      {
        id: '',
        sku: '',
        brandName: '',
        delivery_time: '',
        description: '',
        tax_price: '0.00',
        limits: '',
        total: '0.00',
        checked: false,
        new_sku: ''
      }],
      isShow: false,
      skuList: '',
      checkAll: false,
      checkedList: [],
      checkedArr: [],
      totalAmount: 0.00
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
  },
  methods: {
    addGoods () {
      this.goodsList.push({
        id: '',
        sku: '',
        brandName: '',
        delivery_time: '',
        description: '',
        tax_price: '0.00',
        limits: '',
        total: '',
        new_sku: ''
      })
    },
    delGoods (index) {
      this.goodsList.splice(index, 1)
    },
    onRodeChange (index, item) {
      if (!item.new_sku) { return }
      var num = 0
      this.goodsList.map(response => {
        if (response.new_sku && (item.new_sku === response.sku || item.new_sku === response.plant_sku)) {
          num++
        }
      })
      if (num >= 1) {
        this.$message.error('该商品已存在')
        item.new_sku = ''
        return
      }
      api.onRodeChange({sku: item.new_sku}).then(res => {
        if (res.code === '50000') {
          this.$message.error(res.Message)
        } else if (res.code === '20000') {
          res.items.total = (res.items.number * res.items.tax_price).toFixed(2)
          res.items.new_sku = res.items.plant_sku || res.items.sku
          this.goodsList[index] = Object.assign(this.goodsList[index], res.items)
          this.checkedArr.push(res.items.id)
        }
      })
    },
    sureSku () {
      api.sureSkuList({skuList: this.skuList}).then(res => {
        if (res.items.length <= 0) {
          this.$message.error('代码不存在')
          this.skuList = ''
        } else {
          res.items.map(val => {
            val.total = (val.number * val.tax_price).toFixed(2)
            val.new_sku = val.plant_sku || val.sku
          })
          this.goodsList = res.items.concat(this.goodsList)
        }
        this.isShow = false
      })
    },
    handleCheckAllChange (val) {
      // 全选
      var bawtotal = 0
      if (val) {
        this.goodsList.map(res => {
          res.checked = true
          if (res.id && res.checked) {
            bawtotal += (res.limits * res.tax_price)
          }
        })
        this.totalAmount = bawtotal.toFixed(2)
      } else {
        this.goodsList.map(res => {
          res.checked = false
          if (res.id && res.checked) {
            bawtotal += (res.limits * res.tax_price)
          }
        })
        this.totalAmount = bawtotal.toFixed(2)
      }
    },
    handleCheckedCitiesChange () {
      // 单选 totalAmount
      var bawtotal = 0
      this.goodsList.map(res => {
        if (res.id && res.checked) {
          bawtotal += (res.limits * res.tax_price)
        }
      })
      this.totalAmount = bawtotal.toFixed(2)
    },
    settleAccounts () {
      // 结算
      if (!this.current_user || !this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      var fastList = []
      this.goodsList.map(res => {
        if (res.id && res.checked) {
          var goods = {
            id: res.id,
            number: res.limits
          }
          fastList.push(goods)
        }
      })
      if (fastList.length > 0) {
        localStorage.setItem('fastList', JSON.stringify(fastList))
        localStorage.removeItem('preorderList')
        localStorage.removeItem('nowBuy_goods')
        localStorage.removeItem('cart_checkList')
        this.$router.push({path: '/ConfirmOrder'})
      }
    },
    changeNumber (item) {
      item.total = (item.limits * item.tax_price).toFixed(2)
      this.handleCheckedCitiesChange()
    }
  }
}
</script>
<style scoped>
  .el-input-number{
    margin-top: 15px;
    margin-left: 15px;
    height: 38px;
    width: 110px;
  }
  .fast_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/view/faster/faster.vue